module.exports = __webpack_public_path__ + "f33d7eb77139c645e566f3de3fc10e14.MP3";